export default "__VITE_ASSET__rlTKLi9G__"